import { createIcon } from "@chakra-ui/react";

export const Enter = createIcon({
  displayName: "Enter",
  viewBox: "0 0 24 24",
  d: "M9 18.286H6.429a1.72 1.72 0 0 1-1.715-1.715V7.43A1.72 1.72 0 0 1 6.43 5.714H9A.856.856 0 1 0 9 4H6.429A3.429 3.429 0 0 0 3 7.429v9.142A3.429 3.429 0 0 0 6.429 20H9a.855.855 0 0 0 .857-.857.855.855 0 0 0-.857-.857zm11.996-6.907-5.442-4.793a1.202 1.202 0 0 0-1.29-.196 1.171 1.171 0 0 0-.693 1.064v1.975H9.286a1.43 1.43 0 0 0-1.429 1.428v2.286c0 .788.64 1.429 1.429 1.429h4.285v1.975c0 .456.273.872.694 1.062a1.202 1.202 0 0 0 1.289-.196l5.442-4.753a.85.85 0 0 0 .29-.642.84.84 0 0 0-.29-.64zm-5.71 3.978v-2.532H9.57v-1.714h5.715v-2.5l3.85 3.376-3.85 3.37z",
  defaultProps: {
    "aria-label": "An arrow pointing right within a bracket"
  }
});

export default Enter;
